import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function stripeReducer(state = initialState.stripe, action) {
  const stripe = { ...state };

  switch (action.type) {
    case types.GET_STRIPE_CUSTOMER_DETAILS_SUCCESS:
      stripe.customerDetails = action.data;
      stripe.hasCard = action.data.hasCard;
      return stripe;

    case types.GET_STRIPE_CUSTOMER_DETAILS_ERROR:
      stripe.hasCard = false;
      return stripe;

    case types.CHECK_DISCOUNT_CODE_IS_VALID_SUCCESS: {
      stripe.discount = action.data;
      stripe.discount.code = action.discountCode;
      return stripe;
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./library/app/reducers/stripeReducer.js